import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["emoji"];

  connect() {
  }

  toggle(event) {
    this.emojiTargets.forEach((target) => {
      if (target === event.currentTarget) {
        target.classList.add("ring-[10px]", "ring-slate-200");
      } else {
        target.classList.remove("ring-[10px]", "ring-slate-200");
      }
    });
  }
}
